interface ColorItemType {
  group: string;
  color: string;
  name: string;
}

enum ColorGroups {
  POPULAR = 'Popular',
  WHITE = 'Whites',
  GRAY = 'Grays',
  BROWN = 'Browns',
  RED = 'Reds',
  ORANGE = 'Oranges',
  YELLOW = 'Yellows',
  GREEN = 'Greens',
  BLUE = 'Blues',
  PURPLE = 'Purples',
}

const Colors = [
  { group: ColorGroups.POPULAR, color: '#FFFFFF', name: 'color0' },
  { group: ColorGroups.POPULAR, color: '#d6cab9', name: 'color1' },
  { group: ColorGroups.POPULAR, color: '#e9d5c9', name: 'color2' },
  { group: ColorGroups.POPULAR, color: '#c8e2cc', name: 'color3' },
  { group: ColorGroups.POPULAR, color: '#e9e4da', name: 'color4' },
  { group: ColorGroups.POPULAR, color: '#ddb582', name: 'color5' },
  { group: ColorGroups.POPULAR, color: '#c39c83', name: 'color6' },
  { group: ColorGroups.POPULAR, color: '#b8cccd', name: 'color7' },
  { group: ColorGroups.POPULAR, color: '#b0b9a6', name: 'color8' },
  { group: ColorGroups.POPULAR, color: '#bba088', name: 'color9' },
  { group: ColorGroups.POPULAR, color: '#9d8376', name: 'color10' },
  { group: ColorGroups.POPULAR, color: '#147d87', name: 'color11' },
  { group: ColorGroups.POPULAR, color: '#719ca4', name: 'color12' },
  { group: ColorGroups.POPULAR, color: '#d39952', name: 'color13' },
  { group: ColorGroups.POPULAR, color: '#9f5440', name: 'color14' },
  { group: ColorGroups.POPULAR, color: '#7b90a2', name: 'color15' },
  { group: ColorGroups.POPULAR, color: '#87857e', name: 'color16' },
  { group: ColorGroups.POPULAR, color: '#a76944', name: 'color17' },
  { group: ColorGroups.POPULAR, color: '#7f576d', name: 'color18' },
  { group: ColorGroups.POPULAR, color: '#344d58', name: 'color19' },
  { group: ColorGroups.POPULAR, color: '#5f6d59', name: 'color20' },
  { group: ColorGroups.POPULAR, color: '#434442', name: 'color21' },
  { group: ColorGroups.WHITE, color: '#FFFFFF', name: 'color130' },
  { group: ColorGroups.WHITE, color: '#f1ede0', name: 'color22' },
  { group: ColorGroups.WHITE, color: '#e8ddca', name: 'color23' },
  { group: ColorGroups.WHITE, color: '#f5f4ec', name: 'color24' },
  { group: ColorGroups.WHITE, color: '#ebebe6', name: 'color25' },
  { group: ColorGroups.WHITE, color: '#ebdec4', name: 'color26' },
  { group: ColorGroups.WHITE, color: '#e7e2d2', name: 'color27' },
  { group: ColorGroups.WHITE, color: '#f7edd8', name: 'color28' },
  { group: ColorGroups.WHITE, color: '#eff0ec', name: 'color29' },
  { group: ColorGroups.WHITE, color: '#f3e9d6', name: 'color30' },
  { group: ColorGroups.WHITE, color: '#e5dfd2', name: 'color31' },
  { group: ColorGroups.WHITE, color: '#e5e2da', name: 'color32' },
  { group: ColorGroups.WHITE, color: '#eeebe2', name: 'color33' },
  { group: ColorGroups.GRAY, color: '#d9d9d2', name: 'color34' },
  { group: ColorGroups.GRAY, color: '#999d9e', name: 'color35' },
  { group: ColorGroups.GRAY, color: '#c5c5c3', name: 'color36' },
  { group: ColorGroups.GRAY, color: '#acb0b0', name: 'color37' },
  { group: ColorGroups.GRAY, color: '#b6b9b6', name: 'color38' },
  { group: ColorGroups.GRAY, color: '#cfd2d3', name: 'color39' },
  { group: ColorGroups.GRAY, color: '#aeadac', name: 'color40' },
  { group: ColorGroups.GRAY, color: '#cccfcb', name: 'color41' },
  { group: ColorGroups.GRAY, color: '#cbcecd', name: 'color42' },
  { group: ColorGroups.GRAY, color: '#d1d1cf', name: 'color43' },
  { group: ColorGroups.GRAY, color: '#757574', name: 'color44' },
  { group: ColorGroups.GRAY, color: '#c0c4c6', name: 'color45' },
  { group: ColorGroups.BROWN, color: '#a68a71', name: 'color46' },
  { group: ColorGroups.BROWN, color: '#d5c9bc', name: 'color47' },
  { group: ColorGroups.BROWN, color: '#cab095', name: 'color48' },
  { group: ColorGroups.BROWN, color: '#ddc5af', name: 'color49' },
  { group: ColorGroups.BROWN, color: '#dec7ad', name: 'color50' },
  { group: ColorGroups.BROWN, color: '#a69c91', name: 'color51' },
  { group: ColorGroups.BROWN, color: '#dad3cb', name: 'color52' },
  { group: ColorGroups.BROWN, color: '#e9d6bd', name: 'color53' },
  { group: ColorGroups.BROWN, color: '#e1d0be', name: 'color54' },
  { group: ColorGroups.BROWN, color: '#d3c5af', name: 'color55' },
  { group: ColorGroups.BROWN, color: '#e3ded4', name: 'color56' },
  { group: ColorGroups.BROWN, color: '#5a4840', name: 'color57' },
  { group: ColorGroups.RED, color: '#f6d8d2', name: 'color58' },
  { group: ColorGroups.RED, color: '#c89697', name: 'color59' },
  { group: ColorGroups.RED, color: '#dd84a3', name: 'color60' },
  { group: ColorGroups.RED, color: '#744e5b', name: 'color61' },
  { group: ColorGroups.RED, color: '#e1887f', name: 'color62' },
  { group: ColorGroups.RED, color: '#cb5c5b', name: 'color63' },
  { group: ColorGroups.RED, color: '#a04039', name: 'color64' },
  { group: ColorGroups.RED, color: '#843c41', name: 'color65' },
  { group: ColorGroups.RED, color: '#c49d93', name: 'color66' },
  { group: ColorGroups.RED, color: '#d04838', name: 'color67' },
  { group: ColorGroups.RED, color: '#be3c37', name: 'color68' },
  { group: ColorGroups.RED, color: '#744543', name: 'color69' },
  { group: ColorGroups.ORANGE, color: '#f39d71', name: 'color70' },
  { group: ColorGroups.ORANGE, color: '#e36940', name: 'color71' },
  { group: ColorGroups.ORANGE, color: '#da5736', name: 'color72' },
  { group: ColorGroups.ORANGE, color: '#af6649', name: 'color73' },
  { group: ColorGroups.ORANGE, color: '#eec2ad', name: 'color74' },
  { group: ColorGroups.ORANGE, color: '#f39233', name: 'color75' },
  { group: ColorGroups.ORANGE, color: '#ea7739', name: 'color76' },
  { group: ColorGroups.ORANGE, color: '#d2864e', name: 'color77' },
  { group: ColorGroups.ORANGE, color: '#eadbc9', name: 'color78' },
  { group: ColorGroups.ORANGE, color: '#f5d8ba', name: 'color79' },
  { group: ColorGroups.ORANGE, color: '#dabe9f', name: 'color80' },
  { group: ColorGroups.ORANGE, color: '#c39c83', name: 'color81' },
  { group: ColorGroups.YELLOW, color: '#feebc8', name: 'color82' },
  { group: ColorGroups.YELLOW, color: '#f2dfb5', name: 'color83' },
  { group: ColorGroups.YELLOW, color: '#ffe487', name: 'color84' },
  { group: ColorGroups.YELLOW, color: '#ffca46', name: 'color85' },
  { group: ColorGroups.YELLOW, color: '#eaddc6', name: 'color86' },
  { group: ColorGroups.YELLOW, color: '#fcdba6', name: 'color87' },
  { group: ColorGroups.YELLOW, color: '#e6c17a', name: 'color88' },
  { group: ColorGroups.YELLOW, color: '#ffb729', name: 'color89' },
  { group: ColorGroups.YELLOW, color: '#f7e7cd', name: 'color90' },
  { group: ColorGroups.YELLOW, color: '#f5d6aa', name: 'color91' },
  { group: ColorGroups.YELLOW, color: '#d2ba9d', name: 'color92' },
  { group: ColorGroups.YELLOW, color: '#c79e73', name: 'color93' },
  { group: ColorGroups.GREEN, color: '#d7d9c2', name: 'color94' },
  { group: ColorGroups.GREEN, color: '#bdb98f', name: 'color95' },
  { group: ColorGroups.GREEN, color: '#aaa794', name: 'color96' },
  { group: ColorGroups.GREEN, color: '#72754f', name: 'color97' },
  { group: ColorGroups.GREEN, color: '#d3d9d0', name: 'color98' },
  { group: ColorGroups.GREEN, color: '#96a782', name: 'color99' },
  { group: ColorGroups.GREEN, color: '#698538', name: 'color100' },
  { group: ColorGroups.GREEN, color: '#5a6952', name: 'color101' },
  { group: ColorGroups.GREEN, color: '#b4cccb', name: 'color102' },
  { group: ColorGroups.GREEN, color: '#87d9d2', name: 'color103' },
  { group: ColorGroups.GREEN, color: '#859893', name: 'color104' },
  { group: ColorGroups.GREEN, color: '#596d69', name: 'color105' },
  { group: ColorGroups.BLUE, color: '#acdbdb', name: 'color106' },
  { group: ColorGroups.BLUE, color: '#65c3d6', name: 'color107' },
  { group: ColorGroups.BLUE, color: '#1cadba', name: 'color108' },
  { group: ColorGroups.BLUE, color: '#60818e', name: 'color109' },
  { group: ColorGroups.BLUE, color: '#d7e8ec', name: 'color110' },
  { group: ColorGroups.BLUE, color: '#9ab6c0', name: 'color111' },
  { group: ColorGroups.BLUE, color: '#8d99a1', name: 'color112' },
  { group: ColorGroups.BLUE, color: '#679bb3', name: 'color113' },
  { group: ColorGroups.BLUE, color: '#9ac1dc', name: 'color114' },
  { group: ColorGroups.BLUE, color: '#70869d', name: 'color115' },
  { group: ColorGroups.BLUE, color: '#267ebc', name: 'color116' },
  { group: ColorGroups.BLUE, color: '#40495b', name: 'color117' },
  { group: ColorGroups.PURPLE, color: '#d7d0e1', name: 'color118' },
  { group: ColorGroups.PURPLE, color: '#c1c2d7', name: 'color119' },
  { group: ColorGroups.PURPLE, color: '#9097b4', name: 'color120' },
  { group: ColorGroups.PURPLE, color: '#5e5f7e', name: 'color121' },
  { group: ColorGroups.PURPLE, color: '#e1e2eb', name: 'color122' },
  { group: ColorGroups.PURPLE, color: '#87819b', name: 'color123' },
  { group: ColorGroups.PURPLE, color: '#9076ae', name: 'color124' },
  { group: ColorGroups.PURPLE, color: '#6c5d97', name: 'color125' },
  { group: ColorGroups.PURPLE, color: '#e4e5e7', name: 'color126' },
  { group: ColorGroups.PURPLE, color: '#bfb9bd', name: 'color127' },
  { group: ColorGroups.PURPLE, color: '#a29aa0', name: 'color128' },
  { group: ColorGroups.PURPLE, color: '#6f5f70', name: 'color129' },
] as const;

export { Colors, ColorItemType, ColorGroups };
